import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";
import axiosInstance from "../../../../service/axios.instance";
import { attempt } from "../../../../service/apiResult";

const apiService = new ApiService();

export const appCatalogueCreateUpdate = async (data, editMode, id) => {
  const url = editMode === true
    ? `${apiEndPoints.appCatalogueCreateOrUpdate}/${id}`
    : `${apiEndPoints.appCatalogueCreateOrUpdate}`;

  return attempt(() => (editMode === true
    ? apiService.update(url, data)
    : apiService.post(url, data)));
};

export const getAllAppCatalogue = async (page = 0, size = 10) => {
  try {
    const response = await apiService.get(
      `${apiEndPoints.getAllAppCatalogue}?page=${page}&size=${size}`
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const appCatalogueGetById = async (id) => {
  let result;
  await apiService.get(`${apiEndPoints.appCatalogueGetById}/${id}`)
    .then((response) => {
      result = response;
    })
    .catch((error) => {
      result = error;
    });
  return result;
};

export const deleteAppCatalogue = async (id) =>
  attempt(() => apiService.patch( `${apiEndPoints.deleteAppCatalogue}/${id}/status`, { status: 'DELETED' } ));

export const patchAppCatalogueStatus = async (id, statusUpdate) =>
  attempt(() => apiService.patch( `${apiEndPoints.appCataloguePatchApi}/${id}/status`, { status: statusUpdate } ));

export const getAppServices = async (appCatalogueId) => {
  try {
    const response = await apiService.get(
      `${apiEndPoints.appServiceCreateOrUpdate}/${appCatalogueId}/services`
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const appServiceCreateUpdate = async (appCatalogueId, data, editMode, serviceId) => {
  let result;
  if (editMode) {
    await apiService.update(
      `${apiEndPoints.appServiceCreateOrUpdate}/${appCatalogueId}/services/${serviceId}`,
      data
    )
      .then((response) => { result = response; })
      .catch((error) => { result = error; });
  } else {
    await apiService.post(
      `${apiEndPoints.appServiceCreateOrUpdate}/${appCatalogueId}/services`,
      data
    )
      .then((response) => { result = response; })
      .catch((error) => { result = error; });
  }
  return result;
};

export const uploadAppServiceLogo = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const apiUrl = process.env.REACT_APP_API_URL;
  const response = await axiosInstance.post(
    apiUrl + 'api/v1/ekutir/app-catalogue/upload-image',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return response.data;
};

export const deleteAppService = async (appCatalogueId, serviceId) => {
  try {
    const response = await apiService.delete(
      `${apiEndPoints.appServicePatchApi}/${appCatalogueId}/services/${serviceId}`
    );
    return response;
  } catch (error) {
    return error;
  }
};

export const patchAppServiceStatus = async (appCatalogueId, serviceId, status) => {
  try {
    const response = await apiService.patch(
      `${apiEndPoints.appServicePatchApi}/${appCatalogueId}/services/${serviceId}/status`,
      { status }
    );
    return response;
  } catch (error) {
    return error;
  }
};
